/*
 * routes.js
 *
 * Description: Holds common/global Routes for Module::'Flightplan'.
 *
 * This file is part of: "http://apps.sundair.com/", "Sundair-2019"
 * Copyright 2018,2019.2020  Sundair GmbH
 * Contact:  http://www.sundair.com/
 * @author Learek <michael.broeker@sundair.com>
 *
 */
import HomeFlightplan from '../../../components/flightplan/Home.vue'; // 'Home-Flightplan' ..

export const routesflightplan = [
    { path: '', component: HomeFlightplan },
];
